import React, { memo } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, oneOf } from 'prop-types'

import { LIBRARY_TAB } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import EmptyStateIllustration from 'Pods/ThreeDStudio/Shared/EmptyStateIllustration/EmptyStateIllustration'

// Live region so a search that flips the grid from results to nothing is announced
// instead of silently swapping the cards out.
function NotFoundState({ tab = LIBRARY_TAB.MODELS, onGenerate = null }) {
  const t = useTranslation()

  return (
    <div className="not-found-state" role="status" aria-live="polite">
      <EmptyStateIllustration glyph={tab === LIBRARY_TAB.IMAGES ? 'image' : 'cube'} size="small" />
      <p className="not-found-state__text cgt-body-base-semibold">
        {t('sidebar.library.notFound.text')}
      </p>
      {onGenerate && (
        <Button
          type="secondary"
          size="tiny"
          actionType="button"
          customClass="not-found-state__button"
          onClick={onGenerate}
        >
          {t('sidebar.actions.generateNewImage')}
        </Button>
      )}
    </div>
  )
}

NotFoundState.propTypes = {
  tab: oneOf([LIBRARY_TAB.MODELS, LIBRARY_TAB.IMAGES]),
  onGenerate: func,
}

export default memo(NotFoundState)
